module.exports = __webpack_public_path__ + "img/checkmark_blue.57fe2846.svg";